<div (keydown.enter)="submit()" class="flex flex-col gap-6">

  <section class="flex flex-col gap-4">
    <elcia-label [label]="'app.general' | translate"/>

    @if (code()) {
      <!-- Read-only plan code: displayed as a labelled badge, never editable -->
      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium text-gray-500 uppercase tracking-wide">
          {{ 'licence-plan.code' | translate }}
        </span>
        <span class="inline-flex w-fit items-center rounded-md bg-gray-100 px-2.5 py-1 text-sm font-medium text-gray-700 ring-1 ring-inset ring-gray-200">
          {{ ('licence-plan-code.' + code()) | translate }}
        </span>
      </div>
    }

    <div class="flex gap-2">
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.nameFr" [label]="'product.name-fr' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.nameNl" [label]="'product.name-nl' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.nameEn" [label]="'product.name-en' | translate"/>
      </div>
    </div>

    <!-- stopPropagation lets Enter insert a newline in the textareas instead of submitting -->
    <div (keydown.enter)="$event.stopPropagation()" class="flex gap-2">
      <div class="flex-1">
        <elcia-text-area [control]="form.controls.descriptionFr" [label]="'product.description-fr' | translate"
                         [rows]="3"/>
      </div>
      <div class="flex-1">
        <elcia-text-area [control]="form.controls.descriptionNl" [label]="'product.description-nl' | translate"
                         [rows]="3"/>
      </div>
      <div class="flex-1">
        <elcia-text-area [control]="form.controls.descriptionEn" [label]="'product.description-en' | translate"
                         [rows]="3"/>
      </div>
    </div>

  </section>

  <p-divider/>

  <section class="flex flex-col gap-4">
    <elcia-label [label]="'licence-plan.included-features' | translate"/>

    <!-- Chaque p-checkbox partage le même FormControl tableau ; [value] accumule/retire l'id de la feature -->
    <div class="grid grid-cols-2 gap-x-4 gap-y-2 md:grid-cols-3">
      @for (option of featureOptions(); track option.id) {
        <div class="flex items-center gap-2">
          <p-checkbox [formControl]="form.controls.includedFeatureCodes" [inputId]="'feature-' + option.id"
                      [value]="option.id"/>
          <label [for]="'feature-' + option.id" class="cursor-pointer text-sm text-gray-700">{{ option.name }}</label>
        </div>
      }
    </div>
  </section>

</div>
